export default {
  'center': {
    'common': {
      'search': 'Search',
      'reset': 'Reset',
      'submit': 'Submit',
      'cancel': 'Cancel',
      'confirm': 'Confirm',
      'operation': 'Operation',
      'status': 'Status',
      'createTime': 'Create Time',
      'updateTime': 'Update Time',
      'remark': 'Remark',
      'amount': 'Amount',
      'currency': 'Currency',
      'orderNumber': 'Order Number',
      'memberAccount': 'Member Account',
      'fee': 'Fee',
      'type': 'Type',
      'all': 'All',
      'pending': 'Pending',
      'processing': 'Processing',
      'completed': 'Completed',
      'failed': 'Failed',
      'rejected': 'Rejected',
      'approved': 'Approved',
      'locked': 'Locked',
      'unlocked': 'Unlocked',
      'dateRange': 'Date Range',
      'startDate': 'Start Date',
      'endDate': 'End Date',
      'dateType': 'Date Type',
      'dateType.createTime': 'Create Time',
      'dateType.updateTime': 'Update Time',
      'dateType.completeTime': 'Complete Time',
      'dateType.applyTime': 'Application Time',
      'dateType.successTime': 'Completion Time',
      'noData': 'No Data',
      'startAmount': 'Min Amount',
      'endAmount': 'Max Amount'
    },
    'withdrawal': {
      'title': 'Withdrawal Order Management',
      'config': {
        'title': 'Withdrawal Configuration',
        'basic': {
          'title': 'Basic Withdrawal Configuration',
          'minAmount': 'Minimum Withdrawal Amount',
          'maxAmount': 'Maximum Withdrawal Amount',
          'dailyLimit': 'Daily Withdrawal Limit',
          'monthlyLimit': 'Monthly Withdrawal Limit',
          'feeRate': 'Fee Rate',
          'feeType': 'Fee Type',
          'feeTypes': {
            'fixed': 'Fixed Amount',
            'percentage': 'Percentage'
          }
        },
        'risk': {
          'title': 'Risk Control Configuration',
          'ipLimit': 'IP Limit',
          'deviceLimit': 'Device Limit',
          'locationLimit': 'Location Limit',
          'riskLevel': 'Risk Level',
          'riskLevels': {
            'low': 'Low',
            'medium': 'Medium',
            'high': 'High'
          }
        }
      },
      'order': {
        'title': 'Withdrawal Orders',
        'status': {
          'pending': 'Pending Review',
          'processing': 'Processing',
          'completed': 'Completed',
          'failed': 'Failed',
          'rejected': 'Rejected',
          'waiting': 'Waiting for Payment',
          'paid': 'Paid',
          'dfProcessing': 'Processing Payment',
          'locked': 'Payment Locked',
          'riskLocked':'Locked under review'
        },
        'type': {
          'bank': 'Bank Transfer',
          'crypto': 'Cryptocurrency',
          'other': 'Other',
          'BANK': 'Bank Card',
          'ALIPAY': 'Alipay',
          'WECHAT': 'WeChat',
          'USDT': 'USDT'
        },
        'action': {
          'approve': 'Approve',
          'reject': 'Reject',
          'lock': 'Lock',
          'unlock': 'Unlock',
          'detail': 'Details',
          'confirm': 'Confirm Payment',
          'paid': 'Process Payment',
          'rejectWithdraw': 'Reject Withdrawal',
          'frontRemark': 'Frontend Remark',
          'backRemark': 'Backend Remark',
          'dfFailReason': 'Payout Failure Reason',
          'updateChannel': 'Update Payment Channel',
          'adminUnlock': 'Admin Unlock'
        },
        'info': {
          'orderNumber': 'Order Number',
          'memberAccount': 'Member Account',
          'currency': 'Withdrawal Currency',
          'amount': 'Amount Information',
          'withdrawAmount': 'Withdrawal Amount',
          'fee': 'Fee',
          'realAmount': 'Actual Amount',
          'withdrawMethod': 'Withdrawal Method',
          'operationInfo': 'Operation Information',
          'applyTime': 'Application Time',
          'riskCheckTime': 'Risk Check Time',
          'riskCheckOperator': 'Risk Check Operator',
          'successTime': 'Payment Time',
          'successOperator': 'Payment Operator',
          'channelName': 'Payment Channel',
          'refuseTime': 'Rejection Time',
          'refuseOperator': 'Rejection Operator',
          'timeProgress': 'Withdrawal Time Progress',
          'status': 'Status',
          'remark': 'Remark',
          'manualOperation': 'Manual withdrawal',
          'withdrawShowInfo':'Withdrawal information',
          'showInfoBankAccount':'Bank card account name',
          'showInfoBankNumber':'Bank card number',
          'showInfoBankName':'Bank card name',
          'showInfoUSDTAccount':'USDT address',
          'showInfoUSDTRate':'USDT exchange rate',
          'showInfoUSDTType':'USDT chain type',
          'showInfoRealName':'Name',
          'showInfoAccount':'Account number',
          'showInfoRealAmount':'Payment amount',
          'showInfoCurSign':'Currency',
          'clickCreateOrderTime': 'Member clicked withdrawal',
          'receiveServerTime': 'Server received request',
          'financialOperatorTime': 'Financial processed withdrawal',
          'externalReceiveTime': 'Third-party callback completed',
          'systemGeneratedOrder': 'System generated order',
        },
        'modal': {
          'reject': {
            'title': 'Reject Withdrawal',
            'frontRemark': 'Frontend Remark',
            'backRemark': 'Backend Remark',
            'confirm': 'Confirm',
            'cancel': 'Cancel',
            'success': 'Rejection successful',
            'failed': 'Rejection failed'
          },
          'confirm': {
            'title': 'Confirm Payment',
            'content': 'Are you sure you want to confirm the payment?',
            'confirm': 'Confirm',
            'cancel': 'Cancel',
            'success': 'Payment confirmation successful',
            'failed': 'Payment confirmation failed',
            '70016015':'The amount does not meet the minimum amount of the channel',
            '70016016':'The amount exceeds the maximum amount of the channel',
            '70018018':'The channel parameter configuration is abnormal, please check',
            '70015065':'The payment for this withdrawal order failed. Please try other payment channels',
            '70015073':'This record is being processed. Please do not repeat the operation',
            '70015017':'Payment on behalf of members requires real name verification',
            '70015076':'Please check the latest order status',
          },
          'paid': {
            'title': 'Process Payment',
            'channel': 'Payment Channel',
            'selectChannel': 'Please select a payment channel',
            'confirm': 'Confirm',
            'cancel': 'Cancel',
            'success': 'Payment processing successful',
            'failed': 'Payment processing failed'
          },
          'remark': {
            'title': 'Remark Information',
            'frontRemark': 'Frontend Remark',
            'backRemark': 'Backend Remark',
            'close': 'Close'
          },
          'updateChannel': {
            'title': 'Update Payment Channel',
            'channel': 'Payment Channel',
            'selectChannel': 'Please select a payment channel',
            'confirm': 'Confirm',
            'cancel': 'Cancel',
            'success': 'Payment channel update successful',
            'failed': 'Payment channel update failed'
          }
        }
      }
    },
    'recharge': {
      'title': 'Recharge Order Management',
      'config': {
        'title': 'Recharge Configuration',
        'channel': {
          'title': 'Recharge Channel Configuration',
          'name': 'Channel Name',
          'currency': 'Currency Type',
          'platform': 'Platform Type',
          'status': 'Status',
          'statuses': {
            'enabled': 'Enabled',
            'disabled': 'Disabled'
          }
        }
      },
      'order': {
        'title': 'Recharge Order',
        'info': {
          'orderNumber': 'Order Number',
          'memberAccount': 'Member Account',
          'paymentChanneName':'Channel Name',
          'currency': 'Currency',
          'amount': 'Amount',
          'fee': 'Fee',
          'realAmount': 'Actual Amount',
          'status': 'Order Status',
          'createTime': 'Create Time',
          'payTime': 'Payment Time',
          'orderSource': 'Order Source',
          'platform': 'Pay Method',
          'dateType': 'Date Type',
          'dateRange': 'Date Range',
          'startDate': 'Start Date',
          'endDate': 'End Date',
          'paymentMethod': 'Payment Method',
          'successTime': 'Success Time',
          'successOperator':'Operator',
          'remark': 'Remark',
          'timeInfo': 'Time Information',
          'showOvertimeOnly': 'Show Overtime Orders Only',
          'memberOrderTime': 'Member Order Time',
          'paymentSuccessTime': 'Payment Success Time',
          'timeDetails': {
            't0': 'T0 Click Order',
            't1': 'T1 Order Request',
            't2': 'T2 Generate Order',
            't3': 'T3 Third-party Returns',
            't3_5': 'T3.5 Return to Frontend',
            't4': 'T4 Redirect to Pay',
            't5': 'T5 Callback Response',
            'memberPaying': '🟢 Member paying',
            'paymentTimeout': '🔴 Payment link timeout: T3.5-T0 = {time}',
            'expandFullLink': 'Expand Full Link',
            'collapseFullLink': 'Collapse Full Link'
          },
        },
        'source': {
          'H5': 'H5',
          'IOS': 'IOS',
          'ANDROID': 'ANDROID'
        },
        'status': {
          'pending': 'Pending',
          'processing': 'Processing',
          'completed': 'Completed',
          'failed': 'Failed',
          'rejected': 'Rejected',
          'waiting': 'Waiting',
          'paid': 'Paid',
          'dfProcessing': 'Processing Payment',
          'locked': 'Locked',
          'expired':'Expired',
          'invalid':'Invalid'
        },
        'action': {
          'approve': 'Approve',
          'reject': 'Reject',
          'confirm': 'Confirm',
          'detail': 'Detail',
          'export': 'Export'
        },
        'modal': {
          'approve': {
            'title': 'Approve Recharge Order',
            'remark': 'Remark'
          },
          'reject': {
            'title': 'Reject Recharge Order',
            'reason': 'Reject Reason',
            'remark': 'Remark'
          },
          'confirm': {
            'title': 'Confirm Recharge Order',
            'content': 'Confirm that this recharge order has been received?',
            'confirm': 'Confirm',
            'cancel': 'Cancel'
          }
        }
      }
    },
    'payment': {
      'title': 'Payment Settings',
      'channel': {
        'title': 'Payment Channel Settings',
        'name': 'Channel Name',
        'code': 'Channel Code',
        'type': 'Channel Type',
        'status': 'Status',
        'config': 'Configuration',
        'action': {
          'add': 'Add Channel',
          'edit': 'Edit Channel',
          'delete': 'Delete Channel',
          'enable': 'Enable',
          'disable': 'Disable'
        }
      }
    },
    // Callback Whitelist
    callbackWhitelist: {
      title: 'Callback Whitelist',
      type: {
        label: 'Type',
        placeholder: 'Please select type',
        all: 'All',
        pay: 'Payment',
        withdraw: 'Withdrawal'
      },
      component: {
        label: 'Channel Name',
        placeholder: 'Please enter channel name'
      },
      ip: {
        label: 'IP Address',
        placeholder: 'Please enter IP address',
        formatError: 'Please enter a valid IP address format',
        example: 'Please enter IP address, e.g.: 192.168.1.1'
      },
      createTime: 'Create Time',
      createUser: 'Created By',
      action: {
        search: 'Search',
        reset: 'Reset',
        add: 'Add IP to Whitelist',
        delete: 'Delete',
        deleteConfirm: 'Are you sure you want to delete this whitelist record?',
        deleteSuccess: 'Delete successful',
        deleteFailed: 'Delete failed',
        addSuccess: 'Add successful',
        addFailed: 'Add failed'
      },
      modal: {
        addTitle: 'Add IP to Whitelist',
        type: {
          label: 'Type',
          placeholder: 'Please select type',
          required: 'Please select type'
        },
        component: {
          label: 'Channel Selection',
          placeholder: 'Please select channel',
          required: 'Please select channel'
        },
        ip: {
          label: 'IP Address',
          placeholder: 'Please enter IP address, e.g.: 192.168.1.1',
          required: 'Please enter IP address',
          formatError: 'Please enter a valid IP address format'
        },
        confirm: 'Confirm',
        cancel: 'Cancel'
      }
    },
    paymentSettings: {
      title: 'Payment Settings',
      channel: {
        title: 'Payment Channel',
        search: {
          channelName: 'Channel Name',
          channelNamePlaceholder: 'Please enter channel name',
          paymentGroup: 'Payment Group',
          paymentGroupPlaceholder: 'Please select payment group',
          paymentModel: 'Payment Method',
          paymentModelPlaceholder: 'Please select payment method',
          currency: 'Curreny Type',
          currencyPlaceholder: 'Please select currency type',
          status: 'Status',
          statusPlaceholder: 'Please select status',
          statusEnabled: 'Enabled',
          statusDisabled: 'Disabled',
          search: 'Search',
          button: 'Search',
          reset: 'Reset'
        },
        table: {
          channelName: 'Channel Name',
          paymentGroup: 'Payment Group',
          paymentModel: 'Payment Method',
          payDescription: 'Channel description',
          currency: 'Currency',
          platformType: 'Platform Type',
          minAmount: 'Min Amount',
          maxAmount: 'Max Amount',
          amountRange:'Amount Range',
          agentOverride: 'Agent Override',
          default: 'Default',
          memberLevel:'Member Level',
          agentConfig: 'Agent Config',
          agentConfigNotSet: 'Not Set',
          agentConfigAll: 'All Agents',
          agentConfigPartial: 'Specific Agents',
          agentConfigSet: 'Configured',
          agentConfigOverride: 'Agent Override · Amount Rules',
          agentConfigNote: 'Other agents/regular users: Use global config; Priority: Agent config > Global config.',
          status: 'Status',
          sort:'Sort',
          action: 'Action',
          edit: 'Edit',
          params: 'Parameters',
          delete: 'Delete'
        },
        modal: {
          add: 'Add Payment Channel',
          edit: 'Edit Payment Channel',
          delete: {
            title: 'Confirm Delete',
            content: 'Are you sure you want to delete this payment channel?'
          }
        },
        form: {
          paymentGroup: 'payment group',
          paymentGroupPlaceholder: 'Please select payment group',
          paymentGroupAll:'All',
          paymentGroupOnline:'Online payment',
          paymentGroupOffline:'Offline payment',
          paymentModel: 'Payment method',
          paymentModelPlaceholder: 'Please select payment method',
          channel: 'Channel selection',
          channelPlaceholder: 'Please select channel',
          channelName:'Channel name',
          channelNamePlaceholder:'Please enter channel name',
          currency: 'Currency type',
          currencyPlaceholder: 'Please select currency type',
          platformType: 'Platform type',
          platformTypePlaceholder: 'Please select platform type',
          paymentPlatformAll:'All',
          paymentPlatformPC:'PC terminal',
          paymentPlatformH5:'H5 terminal',
          minAmount: 'Minimum amount',
          minAmountPlaceholder: 'Please enter the minimum amount',
          maxAmount: 'Maximum amount',
          maxAmountPlaceholder: 'Please enter the maximum amount',
          depositStairs:'Accumulation conditions',
          depositStairsPlaceholder:'Please enter the cumulative deposit conditions',
          amountType:'amount type',
          amountTypePlaceholder:'Please select the amount type',
          amountTypeSelect:'fixed amount',
          amountTypeWrite:'fill in the amount',
          amountTypeAll:'all supported',
          amountList:'amount list',
          amountListPlaceholder:'Please enter the amount list, comma separated',
          defaultAmount: 'Default Amount',
          defaultAmountPlaceholder: 'Please enter default amount',
          amountListInRangeError: 'Values in amount list must be between min and max amount',
          defaultAmountInListError: 'Default amount must be included in amount list when using fixed amounts',
          memberLevel:'Member level',
          memberLevelPlaceholder:'Please select a member level',
          memberLevelAll:'All levels',
          walletAccount: 'Wallet account',
          walletAccountPlaceholder: 'Please enter a wallet account',
          walletName: 'Wallet username',
          walletNamePlaceholder: 'Please enter a wallet username',
          payTag:'Remarks',
          payTagPlaceholder:'Please enter remarks',
          payDescription: 'Channel description',
          payDescriptionPlaceholder: 'Please enter channel description',
          sort:'Sort',
          sortPlaceholder:'Please enter sort',
          needMemberName:'Do you need a real name',
          needMemberName1:'Yes',
          needMemberName2:'No',
          usdtAccount:'USDT address',
          usdtAccountPlaceholder:'Please enter a USDT address',
          usdtType:'USDT type',
          usdtTypePlaceholder:'Please select USDT type',
          usdtRate:'USDT exchange rate',
          usdtRatePlaceholder:'Please enter USDT exchange rate',
          usdtRateType:'USDT exchange rate type',
          usdtRateTypeFixed:'Fixed exchange rate',
          usdtRateTypeFloat:'Floating exchange rate',
          bankName:'Bank name',
          bankNamePlaceholder:'Please enter bank name',
          bankAccount:'Bank card account',
          bankAccountPlaceholder:'Please enter bank card account',
          bankNumber:'Bank card number',
          bankNumberPlaceholder:'Please enter bank card number',
          bankAddress:'Bank address',
          bankAddressPlaceholder:'Please enter bank address',
          accountName:'Account name',
          accountNamePlaceholder:'Please enter account name',
          qrCode: 'QR code',
          qrCodeUpload: 'Upload QR code',
          qrCodeTip: 'Please upload QR code image',
          agentSelect: 'Agent Selection (Searchable · Multiple)',
          agentSearchPlaceholder: 'Search agent account...',
          allAgents: 'All Agents',
          unknown: 'Unknown',
          agentConfig: 'Agent Configuration (Override Global Amount)',
          agentConfigNote: '(Collapsed by default, configure only when needed)',
          agentConfigValidation: 'Validation: Min ≤ Max; Default amount must be within range; When fixed amount, "Default amount" must be included in amount list; Amount list values must be within range.',
          agentConfigDisabled: 'Agent configuration is disabled, please enable the switch to configure agent rules',
          status: 'Status',
          // Agent configuration validation messages
          agentSelectRequired: 'Please select agent',
          loading: 'Loading...',
          noData: 'No data',
          minAmountRequired: 'Minimum amount cannot be empty',
          maxAmountRequired: 'Maximum amount cannot be empty',
          minAmountError: 'Minimum amount must be less than maximum amount',
          maxAmountError: 'Maximum amount must be greater than minimum amount',
          defaultAmountError: 'Default amount must be between minimum and maximum amount',
          amountListRequired: 'Amount list is required when amount type is fixed',
          // Common messages
          missingDataId: 'Missing required data identifier, cannot update record',
          updateSuccess: 'Update successful',
          addSuccess: 'Add successful',
          updateFailed: 'Update failed',
          addFailed: 'Add failed',
          formValidationFailed: 'Form validation failed',
          formValidationFailedCheck: 'Form validation failed, please check input content',
          operationFailed: 'Operation failed, please try again',
          fetchAgentListFailed: 'Failed to fetch agent list'
        },
        param: {
          title: 'Parameter Configuration',
          merchantId: 'Merchant ID',
          merchantKey: 'Merchant Key',
          apiUrl: 'API URL',
          notifyUrl: 'Notify URL',
          remark: 'Remark',
          alipayAppId: 'Alipay App ID',
          alipayPrivateKey: 'Alipay Private Key',
          alipayPublicKey: 'Alipay Public Key',
          wxAppId: 'WeChat App ID',
          wxMchId: 'WeChat Merchant ID',
          wxApiKey: 'WeChat API Key',
          gatewayUrl: 'Gateway URL',
          returnUrl: 'Return URL',
          signType: 'Sign Type',
          version: 'Version',
          required: 'Please enter required field',
          fetchError: 'Failed to fetch parameter list',
          saveSuccess: 'Save successful',
          saveError: 'Save failed'
        }
      },
      method: {
        title: 'Payment Method',
        search: {
          paymentMethodName: 'Payment Method Name',
          paymentMethodNamePlaceholder: 'Please enter payment method name',
          curSign: 'Currency Type',
          curSignPlaceholder: 'Please select currency type',
          paymentType: 'Payment Type',
          paymentTypePlaceholder: 'Please select payment type',
          status: 'Status',
          statusPlaceholder: 'Please select status',
          statusEnabled: 'Enabled',
          statusDisabled: 'Disabled',
          button: 'Search',
          reset: 'Reset'
        },
        table: {
          paymentGroup: 'Payment Group',
          paymentModel: 'Payment Method',
          currency: 'Currency Type',
          platformType: 'Platform Type',
          platformTypeAll: 'All',
          platformTypePC: 'PC',
          platformTypeH5: 'H5',
          logo: 'Icon Logo',
          sort: 'Sort',
          status: 'Status',
          action: 'Action',
          edit: 'Edit',
          delete: 'Delete'
        },
        modal: {
          add: 'Add Payment Method',
          edit: 'Edit Payment Method',
          delete: {
            title: 'Confirm Delete',
            content: 'Are you sure you want to delete this payment method?'
          },
          success: {
            create: 'Created successfully',
            update: 'Updated successfully',
            createFailed: 'Creation failed',
            updateFailed: 'Update failed'
          }
        },
        form: {
          basicInfo: 'Basic Information',
          paymentGroup: 'Payment Group',
          paymentGroupPlaceholder: 'Please select payment group',
          paymentGroupAll: 'All Group',
          paymentGroupOnline: 'Online Payment',
          paymentGroupOffline: 'Offline Payment',
          currency: 'Currency',
          currencyPlaceholder: 'Please select currency',
          paymentModel: 'Payment Method',
          paymentModelPlaceholder: 'Please enter payment method',
          paymentModelName: 'Payment Method Name',
          paymentModelNamePlaceholder: 'Please enter payment method name',
          paymentShowName:'payment method display name',
          paymentShowNamePlaceholder:'Please enter the payment method display name',
          payTag:'payment method tag',
          payTagPlaceholder:'Please enter the payment method tag',
          platformType: 'Platform Type',
          platformTypePlaceholder: 'Please select platform type',
          platformTypeAll: 'All',
          platformTypePC: 'PC',
          platformTypeH5: 'H5',
          sort: 'Sort',
          sortPlaceholder: 'Please enter sort order',
          iconSettings: 'Icon Settings',
          pcLogo: 'PC Logo',
          h5Logo: 'H5 Logo',
          otherInfo: 'Other Information',
          remark: 'Remark',
          remarkPlaceholder: 'Please enter remark',
          confirm: 'Confirm',
          cancel: 'Cancel'
        }
      },
      withdrawalSettings: {
        withdrawalMethod: {
          button: {
            edit: 'Edit',
            delete: 'Delete'
          }
        }
      }
    },
    'withdrawalSettings': {
      'withdrawalMethod': {
        'title': 'Withdrawal Method Settings',
        'search': {
          'searchKeyword': 'Type Name',
          'searchKeywordPlaceholder': 'Please enter type name',
          'status': 'Status',
          'statusPlaceholder': 'Please select status',
          'statusAll': 'All',
          'statusEnabled': 'Enabled',
          'statusDisabled': 'Disabled',
          'curSign': 'Currency',
          'curSignPlaceholder': 'Please select currency',
          'button': 'Search',
          'reset': 'Reset'
        },
        'table': {
          'typeName': 'Withdrawal Type',
          'showName': 'Withdrawal Name',
          'showRemark': 'Frontend Tip',
          'logoPic':'Display icon',
          'logoPicPC':'PC terminal icon',
          'logoPicH5':'H5 terminal icon',
          'amountRange':'Amount range',
          'curSign': 'Currency',
          'minAmount': 'Min Amount',
          'maxAmount': 'Max Amount',
          'overAmount': 'Over Amount',
          'fee': 'Fee',
          'sort': 'Sort',
          'status': 'Status',
          'updateInfo': 'Update Info',
          'action': 'Action'
        },
        'modal': {
          'add': 'Add Withdrawal Method',
          'edit': 'Edit Withdrawal Method',
          'delete': {
            'title': 'Delete Confirmation',
            'content': 'Are you sure you want to delete this withdrawal method?'
          }
        },
        'form': {
          'typeName': 'Type Name',
          'typeNamePlaceholder': 'Please enter type name',
          'showName': 'Display Name',
          'showNamePlaceholder': 'Please enter display name',
          'showRemark': 'Display Remark',
          'showRemarkPlaceholder': 'Please enter display remark',
          'curSign': 'Currency',
          'curSignPlaceholder': 'Please select currency',
          'minAmount': 'Min Amount',
          'minAmountPlaceholder': 'Please enter min amount',
          'maxAmount': 'Max Amount',
          'maxAmountPlaceholder': 'Please enter max amount',
          'overAmount': 'Over Amount',
          'overAmountPlaceholder': 'Please enter over amount',
          'fee': 'Fee',
          'feePlaceholder': 'Please enter fee',
          'sort': 'Sort',
          'sortPlaceholder': 'Please enter sort order',
          'pcImg': 'PC Image',
          'h5Img': 'H5 Image'
        },
        'message': {
          'fetchFailed': 'Failed to fetch data',
          'addSuccess': 'Added successfully',
          'addFailed': 'Add failed',
          'editSuccess': 'Edited successfully',
          'editFailed': 'Edit failed',
          'deleteSuccess': 'Deleted successfully',
          'deleteFailed': 'Delete failed',
          'enableSuccess': 'Enabled successfully',
          'enableFailed': 'Enable failed',
          'disableSuccess': 'Disabled successfully',
          'disableFailed': 'Disable failed'
        },
        'button': {
          'edit': 'Edit',
          'delete': 'Delete'
        }
      },
      'bankSettings': {
        'title': 'Bank Settings',
        'search': {
          'bankShortName': 'Bank Abbreviation',
          'bankShortNamePlaceholder': 'e.g. BPI / BDO',
          'bankFullName': 'Bank Full Name',
          'bankFullNamePlaceholder': 'e.g. Bank of the Philippine Islands',
          'curSign': 'Currency',
          'curSignPlaceholder': 'Please select currency',
          'status': 'Status',
          'statusPlaceholder': 'Please select status',
          'button': 'Search',
          'reset': 'Reset'
        },
        'table': {
          'bankShortName': 'Bank Abbreviation',
          'bankFullName': 'Bank Full Name',
          'curSign': 'Currency',
          'status': 'Status',
          'action': 'Action'
        },
        'button': {
          'add': 'Add',
          'edit': 'Edit',
          'delete': 'Delete',
          'channelMapping': 'Channel Mapping Config'
        },
        'form': {
          'bankShortName': 'Bank Abbreviation',
          'bankShortNamePlaceholder': 'Please enter bank abbreviation',
          'bankFullName': 'Bank Full Name',
          'bankFullNamePlaceholder': 'Please enter bank full name',
          'curSign': 'Currency',
          'curSignPlaceholder': 'Please select currency'
        },
        'modal': {
          'add': 'Add Bank Info',
          'edit': 'Edit Bank Info',
          'delete': {
            'title': 'Confirm Delete',
            'content': 'Are you sure you want to delete this bank info?'
          },
          'channelMapping': 'Channel Mapping Configuration'
        },
        'message': {
          'fetchFailed': 'Failed to fetch data',
          'createSuccess': 'Created successfully',
          'createFailed': 'Create failed',
          'updateSuccess': 'Updated successfully',
          'updateFailed': 'Update failed',
          'deleteSuccess': 'Deleted successfully',
          'deleteFailed': 'Delete failed',
          'enableSuccess': 'Enabled successfully',
          'enableFailed': 'Enable failed',
          'disableSuccess': 'Disabled successfully',
          'disableFailed': 'Disable failed',
          'operationFailed': 'Operation failed, please try again',
          'channelMappingComingSoon': 'Channel mapping configuration feature is under development',
          'fetchChannelMappingFailed': 'Failed to fetch channel mapping configuration',
          'channelMappingSaveSuccess': 'Channel mapping configuration saved successfully',
          'channelMappingSaveFailed': 'Failed to save channel mapping configuration',
          'bankInfoIdRequired': 'Bank info ID is required',
          '70023003': 'Bank short name already exists, cannot add duplicate bank short name',
          '70023004': 'Bank full name already exists, cannot add duplicate bank full name',
          '70023005': 'Bank name already exists, cannot add duplicate bank name'
        },
        'channelMapping': {
          'paymentChannel': 'Payment Channel',
          'channelName': 'Channel Name',
          'bankCode': 'Payment Code (BankCode passed to channel)',
          'bankCodePlaceholder': 'e.g.: PH_AUB / 161319 / BC00007',
          'notSupported': '(Not supported)',
          'description': 'Description: When the system makes a payment, it will look up the payment code configured here based on "Bank Short Name + Payment Channel" and pass it to the third-party channel. Empty bankCode means the channel is not supported.'
        }
      },
      'paidChannel': {
        'title': 'Paid Channel Settings',
        'search': {
          'channelName': 'Channel Name',
          'channelNamePlaceholder': 'Please enter channel name',
          'channelType': 'Channel Type',
          'channelTypePlaceholder': 'Please select channel type',
          'curSign': 'Currency',
          'curSignPlaceholder': 'Please select currency',
          'status': 'Status',
          'statusPlaceholder': 'Please select status',
          'statusAll': 'All',
          'statusEnabled': 'Enabled',
          'statusDisabled': 'Disabled',
          'button': 'Search',
          'reset': 'Reset'
        },
        'table': {
          'channelName': 'Channel Name',
          'componentName': 'Payment Channel',
          'channelType': 'Withdrawal Method',
          'curSign': 'Currency',
          'minAmount': 'Min Amount',
          'maxAmount': 'Max Amount',
          'fee': 'Fee',
          'status': 'Status',
          'updateInfo': 'Update Info',
          'action': 'Action'
        },
        'modal': {
          'add': 'Add Paid Channel',
          'edit': 'Edit Paid Channel',
          'delete': {
            'title': 'Confirm Delete',
            'content': 'Are you sure you want to delete this paid channel?'
          },
          'param': {
            'title': '{{channelName}} Parameter Configuration',
            'cancel': 'Cancel',
            'save': 'Save',
            'noParams': 'No parameter configuration available',
            'inputPlaceholder': 'Please enter {{key}}'
          }
        },
        'form': {
          'channelName': 'Channel Name',
          'channelNamePlaceholder': 'Please enter channel name',
          'componentName': 'Component Name',
          'componentNamePlaceholder': 'Please select component',
          'channelType': 'Channel Type',
          'channelTypePlaceholder': 'Please select channel type',
          'curSign': 'Currency',
          'curSignPlaceholder': 'Please select currency',
          'minAmount': 'Min Amount',
          'minAmountPlaceholder': 'Please enter min amount',
          'maxAmount': 'Max Amount',
          'maxAmountPlaceholder': 'Please enter max amount',
          'fee': 'Fee',
          'feePlaceholder': 'Please enter fee'
        },
        'message': {
          'fetchFailed': 'Failed to fetch data',
          'addSuccess': 'Added successfully',
          'addFailed': 'Add failed',
          'editSuccess': 'Edited successfully',
          'editFailed': 'Edit failed',
          'deleteSuccess': 'Deleted successfully',
          'deleteFailed': 'Delete failed',
          'enableSuccess': 'Enabled successfully',
          'enableFailed': 'Enable failed',
          'disableSuccess': 'Disabled successfully',
          'disableFailed': 'Disable failed',
          'paramSaveSuccess': 'Parameters saved successfully',
          'paramSaveFailed': 'Failed to save parameters'
        },
        'button': {
          'add': 'Add',
          'edit': 'Edit',
          'delete': 'Delete',
          'param': 'Parameters'
        }
      }
    },
    'riskWithdrawConfig': {
      'title': 'Risk Withdrawal Configuration',
      'section': {
        'currencyConfig': 'Currency Configuration'
      },
      'status': {
        'enabled': 'Enabled',
        'disabled': 'Disabled'
      },
      'button': {
        'save': 'Save'
      },
      'input': {
        'placeholder': 'Enter threshold'
      },
      'message': {
        'fetchFailed': 'Failed to fetch configuration list',
        'editSuccess': 'Save successful',
        'editFailed': 'Save failed'
      },
      'configGroup': {
        'netAmount': 'Net Amount(fixed amount)',
        'netPercent': 'Net Amount(percentage)',
        'winLost': 'User Win/Loss',
        'withdrawAmount': 'Withdrawal Amount',
        'bonusPercent': 'Bonus Percentage',
        'bonusAmount':'Bonus Amount',
        'riskModel': 'Risk Control Mode',
        'riskRule': 'Withdrawal Amount Rule',
        'bonusSection': 'Bonus',
        'arbitrageSection': 'Game Arbitrage Risk'
      },
      'sectionTitle': {
        netDiff: '1) Net Deposit-Withdraw Diff (Fixed + Percent)',
        userWinLost: '1.2 User Win/Loss (Optional)',
        withdrawAmountRule: '1.3 Withdrawal Amount Rule (VIP Range, VIP0=Non-member)',
        bonus: '2) Bonus (Independent Rule)',
        arbitrage: '3) Game Arbitrage Risk (Hit→Manual Review)',
        noDeposit: '0-Deposit User Suspected Arbitrage',
        initDeposit: 'First-Deposit Suspected Arbitrage',
        deviceIP: 'Same Device/IP Multi-Account Suspected Arbitrage'
      },
      'riskRuleFields': {
        vipMin: 'VIP Min',
        vipMax: 'VIP Max',
        successWithdraw: 'Success Withdraw=0',
        successWithdrawStatus: 'Status',
        successTopUp: 'Success TopUp=0',
        successTopUpStatus: 'Status',
        successDeposit: 'Success Deposit>0',
        successDepositStatus: 'Status',
        totalX: 'Daily Total X',
        totalY: 'Daily Total Y',
        totalZ: 'Daily Total Z'
      },
      'arbitrageFields': {
        balance: 'Balance',
        profitRisk: 'High-Risk Profit %',
        deposit: 'Bet Amount',
        historyNum: 'History Deposit Count',
        balanceDepositMul: 'Balance/Deposit Multiple',
        depoistStart: 'Deposit Range Start',
        depoistEnd: 'Deposit Range End',
        deviceStart: 'Device Range Start',
        deviceEnd: 'Device Range End',
        iPStart: 'IP Range Start',
        iPEnd: 'IP Range End'
      },
      'riskModel': {
        'auto': 'Auto Review',
        'manual': 'Manual Review'
      },
      'globeStatus': {
        enabled: 'Enabled',
        disabled: 'Disabled'
      },
      'descriptions': {
        'netAmount': 'Total deposit and withdrawal difference = total withdrawal - total deposit<br/>Deposit and withdrawal difference percentage = total withdrawal / total deposit * 100%<br/>When the deposit and withdrawal difference of the current user is greater than the set value, and both conditions are met at the same time, it will enter manual approval',
        'netPercent': 'Total deposit and withdrawal difference = total withdrawal - total deposit<br/>Deposit and withdrawal difference percentage = total withdrawal / total deposit * 100%<br/>When the deposit and withdrawal difference of the current user is greater than the set value, and both conditions are met at the same time, it will enter manual approval',
        'winLost': 'User win/loss = value of user\'s cumulative win/loss. If it is positive, it means the user is profitable.<br/>When the user\'s win/loss exceeds the set value, it will enter manual review.',
        'withdrawAmount': 'When the withdrawal amount = the absolute value of the withdrawal amount this time, when the current user\'s withdrawal amount is greater than the set value, enter manual review',
        'bonusPercent': 'Total discount ratio = total discount received / total deposit amount * 100%<br/>Total discount amount = absolute value of discount received<br/>When the absolute value of the current user\'s total discount amount is greater than the set value, and both conditions are met at the same time, it will enter manual review',
        'bonusAmount': 'Total discount ratio = total discount received / total deposit amount * 100%<br/>Total discount amount = absolute value of discount received<br/>When the absolute value of the current user\'s total discount amount is greater than the set value, and both conditions are met at the same time, it will enter manual review',
        'riskModel': ''
      },
      addRange: 'Add Range',
      delete: 'Delete',
      ruleHitDesc: 'When any enabled rule is hit → withdrawal enters [Manual Review].',
      hintPrefix: 'Hint: ',
      autoHintDescBody: 'Withdrawal orders that hit any of the following rules will enter [Manual Review]; otherwise auto review applies.',
      autoHintDesc: 'Hint: Withdrawal orders that hit any of the following rules will enter [Manual Review]; otherwise auto review applies.',
      balanceCalPrefix: 'Risk balance (withdrawal risk caliber): ',
      balanceCalBody: 'Account balance + current withdrawal amount + pending withdrawal orders + unsettled bet amount.',
      balanceCalDesc: 'Risk balance (withdrawal risk caliber): Account balance + current withdrawal amount + pending withdrawal orders + unsettled bet amount.',
      hitRuleTitle: '1) Withdrawal Hit Rules',
      tableRuleName: 'Rule Name',
      tableCondition: 'Condition',
      tableThreshold: 'Threshold',
      tableStatus: 'Status',
      tableConfig: 'Config',
      netDiffCondition: 'Net diff = total withdrawal - total deposit ≥ fixed threshold; and net diff % ≥ % threshold (when both enabled).',
      netDiffRowName: 'Net deposit-withdraw diff (fixed / percent)',
      fixedAmountLabel: 'Fixed amount ≥',
      percentLabel: 'Percent ≥',
      winLostRowName: 'User cumulative win/loss threshold',
      winLostCondition: 'User cumulative win/loss (or net) reaches threshold.',
      bonusRowName: 'Bonus anomaly (ratio / amount)',
      bonusCondition: 'Total bonus ratio and total bonus amount both ≥ threshold.',
      bonusPercentLabel: 'Bonus ratio ≥',
      bonusAmountLabel: 'Bonus amount ≥',
      vipRangeHint: 'Range: vip_min ≤ VIP level ≤ vip_max; no overlap; ascending by vip_min. (e.g. 0-0 non-member; 1-3 / 4-6 / 7-10)',
      noHistoryWithdraw: 'No withdraw history',
      noHistoryDeposit: 'No deposit history',
      hasDepositRecord: 'Has deposit record',
      dailyThresholdXYZ: 'Daily total (X/Y/Z)',
      noDepositMuted: 'History deposit count=0; net win either negative does not trigger.',
      deviceIPMuted: 'Range supports 0-0 for no limit; Y ≥ X.',
      sectionTitleNetDiffSub: '1.1 Net Deposit-Withdraw Diff (Fixed Amount + Percent)',
      sectionTitleUserWinLostSub: '1.2 User Win/Loss (Optional)',
      sectionTitleWithdrawAmountRuleSub: '1.3 Withdrawal Amount Rule (VIP Range Configurable, VIP0=Non-member)',
      sectionTitleBonusSub: '2) Bonus (Independent Rule)',
      sectionTitleArbitrageSub: '3) Game Arbitrage Risk (Hit→Manual Review)',
      netDiffRuleDef: 'Rule: <b>Net diff = Total withdrawal - Total deposit</b>; <b>Net diff % = (Total withdrawal / Total deposit) × 100%</b>.<br />',
      netDiffHitLogic: 'Hit logic: User\'s net diff <b>≥</b> threshold; when both fixed amount and percent are enabled, <b>both must be met (AND)</b> to trigger manual review.',
      statusEnabled: 'Enabled',
      statusOpen: 'On',
      operation: 'Action',
      vipRangeIntro: 'Configure by "VIP level range": ',
      vipRangeIntroBold: 'vip_min=0 and vip_max=0 means non-member.',
      riskRuleHitDesc: 'Any [enabled] condition in the range (OR) → Manual review.',
      vipRangeLabel: 'VIP Level Range',
      singleWithdrawThreshold: 'Single Withdrawal Threshold (X)',
      bonusRuleDef: 'Rule: ',
      bonusRuleDefPart1: '<b>Total bonus % = (Total bonus received / Total deposit) × 100%</b>; ',
      bonusRuleDefPart2: '<b>Total bonus amount = Absolute value of bonus received</b>.<br />',
      bonusHitLogic: 'Hit logic: User\'s total bonus (absolute) and bonus % both <b>≥</b> threshold; both must be met (AND) for manual review.',
      tableNote: 'Note',
      depositRange: 'Deposit Count Range',
      deviceRange: 'Registered Device Count Range',
      ipRange: 'Registered IP Count Range',
      balanceGt: 'Risk Control Balance >',
      profitRiskGt: 'High-Risk Profit % >',
      depositLt: 'Bet Amount <',
      historyNumLt: 'History Deposit Count <',
      balanceDepositMulGt: 'Risk Control Balance/Deposit Multiple >',
      saveConfig: 'Save Config'
    }
  },

  // Add manualBalance translations
  'manualBalance': {
    'title': 'Member Adjustment Records',
    'dateRange': 'Adjustment Time',
    'startDate': 'Start Date',
    'endDate': 'End Date',
    'dateRangeExceeded': 'Query time range cannot exceed {days} days',
    'memberAccount': 'Member Account',
    'enterMemberAccount': 'Please enter member account',
    'transNo': 'Order Number',
    'enterTransNo': 'Please enter order number',
    'subType': 'Adjustment Type',
    'selectSubType': 'Please select adjustment type',
    'manualIn': 'Manual Deposit',
    'manualOut': 'Manual Withdrawal',
    'manualInNotIncludeOrder': 'Manual Deposit Not Include Order',
    'manualOutNotIncludeOrder': 'Manual Withdrawal Not Include Order',
    'badDebtOrder': 'Bad Debt Order',
    'agentIn': 'Agent Deposit',
    'agentOut': 'Agent Transfer Out',
    'curSign': 'Currency',
    'selectCurrency': 'Please select currency',
    'search': 'Search',
    'reset': 'Reset',
    'agentLine': 'Agent Line',
    'unknownType': 'Unknown Type',
    'amount': 'Adjustment Amount',
    'method': 'Method',
    'included': 'Included',
    'notIncluded': 'Not Included',
    'remark': 'Remark',
    'beforeAmount': 'Before Balance',
    'afterAmount': 'After Balance',
    'externalBetflow': 'Flow Amount',
    'createUser': 'Operator',
    'enterCreateUser': 'Please enter operator',
    'export': 'Export',
    'exportLoading': 'Generating export file, please wait...',
    'exportSuccess': 'Export task submitted, please check download list',
    'createUserAndTime': 'Operator/Time',
    'totalCount': 'Total Count',
    'totalAmount': 'Total Amount'
  }
};
